import type { SupplierProductGetResponseChildType } from "@sellar-io/api-v2/types";
import { useState } from "react";
import { Icon } from "../../../../../../../components";
import {
  Dialog,
  DialogNavigation,
} from "../../../../../../../components/modal/Dialog";

import { ProductCategoryItemDeliveryChargeRow } from "./ProductCategoryItemDeliveryChargeRow";

export const ProductCategoryItemDeliveryChargesTabContent = ({
  product,
}: {
  product: SupplierProductGetResponseChildType;
}) => {
  const [active, setActive] = useState<boolean>(false);
  const onDismiss = () => setActive(false);
  return (
    <div className={"flex flex-col gap-4 pt-4"}>
      <div
        className={
          "overflow-x-auto rounded-lg border border-solid border-gray-200"
        }
      >
        <table className={"w-full table-auto border-separate border-spacing-0"}>
          <thead className={"text-left"}>
            <tr className={"border-b border-solid border-gray-200 bg-gray-50"}>
              <th className={"left-0 px-4 py-1"}>Delivery tier</th>
              <th className={"w-2/12 px-4 py-1"}>
                <div
                  className={"flex cursor-pointer items-center gap-2"}
                  onClick={() => setActive(true)}
                >
                  Delivery charge{" "}
                  <Icon size={0.6} icon={"INFORMATION_OUTLINE"} />
                </div>
              </th>
            </tr>
          </thead>
          <tbody className={"divide-y"}>
            <ProductCategoryItemDeliveryChargeRow
              fulfillmentType={"direct"}
              name={"Direct"}
              product={product}
            />
            <ProductCategoryItemDeliveryChargeRow
              fulfillmentType={"courier"}
              name={"Courier"}
              product={product}
            />
            <ProductCategoryItemDeliveryChargeRow
              fulfillmentType={"haulier"}
              name={"Haulier"}
              product={product}
            />
            <ProductCategoryItemDeliveryChargeRow
              fulfillmentType={"collection"}
              name={"Collection"}
              product={product}
            />
          </tbody>
        </table>
      </div>
      <Dialog active={active} onDismiss={onDismiss}>
        <DialogNavigation
          onClickLeftIcon={onDismiss}
          leftIcon={"CHEVRON_DOWN"}
          title={"About 'Delivery charge'"}
          description={
            "This is the delivery charge per item added to the basket for each delivery tier."
          }
        />
      </Dialog>
    </div>
  );
};
